import React, { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Avatar, Box, Button, Stack, Typography, useTheme } from '@mui/material';
import ScrollBox from '../../../components/ScrollBox';
import LogoutPopup from '../../../components/LogoutPopup';
import { useState } from 'react';
import BackButton from '../../../components/BackButton';
import LabelTxt from '../../../components/LabelTxt';
import { useAuthContext } from '../../../context/AuthContext';
import constants from '../../../utils/Constants';
import { useQuery, useQueryClient } from 'react-query';
import QueryKey from '../../../utils/QueryKey';
import { getSingleAmtcUserServ, updateEmpStatusServ } from '../../../services/amtc-service';
import { formatName, formatUserType, isNotEmpty } from '../../../utils/format';
import { customAlert, notify } from '../../../components/notify';
import { getFileUrl } from '../../../services/s3-service';
import BlurImg from '../../../components/BlurImg';
import route from '../../../utils/Routes';
import BgBoxOld from '../../../components/BgBoxOld';
import ComProjCard from '../../../components/ComProjCard';
import { rmvProjFrSourceUserServ } from '../../../services/source-service';
import StyledSwitch from '../../../components/StyledSwitch';
import EditUsernameMdl from '../../ComUser/EditUsernameMdl';

function AmtcProfilePage({ type = "myinfo" }) {
    const theme = useTheme();
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { setLoadingScreen, ctxtUser, setAsyncLoading, ctxtlogout } = useAuthContext();
    const [lgOpen, setLgOpen] = useState(false);
    const detailstyle = { display: "inline-block", fontSize: 13, fontWeight: 400, mt: 2, width: 350 }
    const namestyle = { fontSize: 13, fontWeight: 500, mt: 2, display: "inline-block", width: 120 }
    const [searchParams] = useSearchParams();
    const qUserId = searchParams.get("userId");

    const userId = type === "myinfo" ? ctxtUser?.userId : qUserId;

    const { isLoading, isError, error, data: userData, refetch } = useQuery([QueryKey.comUserProfile, userId],
        () => getSingleAmtcUserServ(userId),
        {
            enabled: isNotEmpty(userId),
            refetchOnMount: true,
            refetchOnWindowFocus: false,
        });

    const { isLoading: isImgLoading, isError: isImgErr, error: imgErr, data: imgUrl } = useQuery([QueryKey.img, userData?.profileImg],
        () => getFileUrl({ fileKey: userData?.profileImg }), {
        enabled: isNotEmpty(userData?.profileImg),
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        keepPreviousData: true
    });

    const [usernameMdl, setUsernameMdl] = useState(false);
    const handleUsernameMdlClose = () => setUsernameMdl(false);
    const handleUsernameMdlOpen = () => setUsernameMdl(true);

    useEffect(() => {
        setLoadingScreen(isImgLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isImgLoading]);


    useEffect(() => {
        if (isLoading) {
            setLoadingScreen(true);
        } else {
            setLoadingScreen(false);
        }
    }, [isLoading, setLoadingScreen]);



    function handleLgOpen() {
        setLgOpen(true)
    }

    function handleLgClose() {
        setLgOpen(false)
    }

    async function handleLogout() {
        try {
            setAsyncLoading(true);
            await ctxtlogout();
            setAsyncLoading(false);
        } catch (error) {
            console.log(error)
            customAlert(error)
        }
    }

    function handleEditBtnClick() {
        navigate(route.aEditAmtcEmp, { state: { userId } });
    };

    async function handleProjRmvClick(i) {
        setLoadingScreen(true);
        try {
            const payload = {
                userId,
                projIdStrg: i.projIdStrg
            }
            const { message } = await rmvProjFrSourceUserServ(payload);
            notify("success", message);
            queryClient.invalidateQueries();
            // navigate(0, { replace: true });
        } catch (error) {
            console.log(error)
            customAlert(error)
        }
        setLoadingScreen(false);
    }

    function handleAssignClick() {
        navigate(route.aAssSourceEmp, {
            state: {
                userId,
                empName: formatName(userData?.fName, userData?.lName), username: userData?.username
            }
        });
    }

    async function updateEmpStatus(i) {
        setAsyncLoading(true);
        try {
            let status = i.status === 1 ? 0 : 1;
            const isComUser = constants.comUserArr.includes(i?.userType);
            const { message } = await updateEmpStatusServ({ userId: i.userId, status, isComUser });
            notify("success", message);
            refetch();
        } catch (err) {
            console.log(err);
            customAlert(err)
        }
        setAsyncLoading(false)
    }

    if (isError) {
        customAlert(error);
        return <h2>Something went wrong</h2>
    }

    if (isImgErr) {
        customAlert(imgErr);
        return <h2>Something went wrong</h2>
    }

    return (
        <ScrollBox height={"100%"} width={"100%"}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ width: "100%", mb: 1 }}>
                <BackButton width={"20%"} />
                <Stack width={"60%"} alignItems={"center"}>
                    <Typography style={{ fontSize: 18, fontWeight: 500 }} > {type === "myinfo" ? "My Profile" : "AMTC Employee Profile"}</Typography>
                </Stack>
                <Stack direction={"row"} alignItems={"center"} justifyContent={"end"} gap={2} width={"20%"}>
                    {(type === "myinfo" && ctxtUser?.userType === constants.admin) && <Button variant='outlined'
                        onClick={handleEditBtnClick} sx={{
                            fontSize: 13,
                            color: theme?.palette?.custom?.btn, borderColor: theme?.palette?.custom?.btn, height: 30
                        }}>
                        Edit Info</Button>}
                    {(type === "user" && ctxtUser?.userType === constants.admin && ctxtUser?.userId === userData?.userId) &&
                        <Button variant='outlined' onClick={handleEditBtnClick} sx={{
                            fontSize: 13,
                            color: theme?.palette?.custom?.btn, borderColor: theme?.palette?.custom?.btn, height: 30
                        }}>
                            Edit Info</Button>}
                    {type === "myinfo" && <Button onClick={handleLgOpen} variant="contained"
                        sx={{ borderRadius: 2, backgroundColor: "red", width: 100, fontSize: 14, color: "white", padding: 0.1, }}>
                        LOGOUT</Button>}

                    {(type === "user" && ctxtUser?.userType === constants.admin && userData?.userType !== constants.admin) &&
                        <Stack direction={"row"} alignItems={"center"} gap={2}>
                            <Button variant='contained' onClick={handleUsernameMdlOpen} sx={{
                                fontSize: 13, bgcolor: theme?.palette?.custom?.btn, height: 30, color: "white"
                            }}>Update Username</Button>
                            <Button variant='outlined' onClick={handleEditBtnClick} sx={{
                                fontSize: 13, color: theme?.palette?.custom?.btn, borderColor: theme?.palette?.custom?.btn, height: 30
                            }}>Edit Info</Button>
                        </Stack>
                    }

                </Stack>
            </Stack>
            <BgBoxOld height={"93%"} py={1}>
                <Stack direction={"row"} width={"100%"} justifyContent={"space-between"} height={"100%"} position={"relative"}>
                    <Stack sx={{}}>
                        <Stack direction={"row"} sx={{ alignItems: "center" }} gap={2} mt={2}>
                            <Avatar sx={{ height: 90, width: 90 }} >
                                <BlurImg imgUrl={imgUrl} alt={"profile_image"} />
                            </Avatar>
                            <Typography sx={{ fontSize: 15, fontWeight: 500 }}>{formatName(userData?.fName, userData?.lName)}</Typography>
                        </Stack>
                        <LabelTxt typoname={"Employee ID"} typodetail={userData?.empId} overflow={40} namestyle={namestyle} detailstyle={detailstyle} />
                        <LabelTxt typoname={"Employee Role"} typodetail={formatUserType(userData?.userType)} overflow={40} namestyle={namestyle} detailstyle={detailstyle} />
                        <LabelTxt typoname={"Email ID"} typodetail={userData?.username} overflow={40} namestyle={namestyle} detailstyle={detailstyle} />
                        <LabelTxt typoname={"Contact No"} typodetail={userData?.phoneNo} overflow={40} namestyle={namestyle} detailstyle={detailstyle} />
                    </Stack>
                    {userData?.userType === constants.sourcing && <Stack alignItems={"start"} width={"60%"}>
                        <Typography sx={{ fontSize: 16, fontWeight: 500 }}>Project Details</Typography>
                        <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} width={"100%"}>
                            <Typography sx={{ fontSize: 14, fontWeight: 400, color: "rgba(0,0,0,0.8)", mt: 1 }}>Current Projects </Typography>
                            {ctxtUser?.userType === constants.admin && <Button variant='outlined' onClick={handleAssignClick} sx={{
                                fontSize: 13, width: 100, height: 22,
                                color: "green", borderColor: "green"
                            }}>ASSIGN</Button>}
                        </Stack>
                        <ScrollBox height={"30%"} width={"100%"} pr={1}>
                            {(userData?.currProj || []).map((i, index) =>
                                <ComProjCard i={i} key={index} width={"100%"} cardType={"amtc"}
                                    type={ctxtUser?.userType === constants.admin && "curr"}
                                    handleRmvClick={ctxtUser?.userType === constants.admin && handleProjRmvClick} />)}
                        </ScrollBox>
                        <Box border={0.3} borderColor="rgba(0,0,0,0.05)" width={"100%"} my={0.3} />
                        <Typography sx={{ fontSize: 14, fontWeight: 400, color: "rgba(0,0,0,0.8)", mt: 1 }}>Previous Projects </Typography>
                        <ScrollBox height={"51%"} width={"100%"} pr={1}>
                            {(userData?.prevProjRes || []).map((i, index) =>
                                <ComProjCard i={i} key={index} width={"100%"} type={"prev"} cardType={"amtc"} />)}
                        </ScrollBox>
                    </Stack>}
                    <Box position={"absolute"} left={-50} top={10}>
                        <StyledSwitch checked={userData?.status === 1 ? true : false} onClick={() => { updateEmpStatus(userData) }}
                            disabled={(ctxtUser?.userType === constants.admin && userData?.userType !== constants.admin) ? false : true} />
                    </Box>
                </Stack>
            </BgBoxOld>
            <LogoutPopup open={lgOpen} handleClose={handleLgClose} handleLogout={handleLogout} />
            {userData && <EditUsernameMdl modalOpen={usernameMdl} handleModalClose={handleUsernameMdlClose} userData={userData} />}
        </ScrollBox>

    )
}

export default AmtcProfilePage
